import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { AppAlert, AppButton, AppCard, AppSpinner } from '../../components/ui';
import klubService from '../../services/klubService';

const formatDate = (iso) => {
  if (!iso || !/^\d{4}-\d{2}-\d{2}/.test(iso)) return '';
  const [year, month, day] = iso.slice(0, 10).split('-');
  return `${day}/${month}/${year}`;
};

const friendlyError = (error) => {
  const raw = String(error?.message || 'Lien invalide.');
  const marker = ': ';
  const index = raw.lastIndexOf(marker);
  return index >= 0 ? raw.slice(index + marker.length) : raw;
};

const KlubEtapeMailPage = () => {
  const { token } = useParams();
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [data, setData] = useState(null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError('');
    klubService.getEtapeMail(token)
      .then((payload) => {
        if (!cancelled) setData(payload);
      })
      .catch((err) => {
        if (!cancelled) setError(friendlyError(err));
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [token]);

  const confirm = async () => {
    setSaving(true);
    setError('');
    try {
      const payload = await klubService.confirmEtapeMail(token);
      setData(payload);
    } catch (err) {
      setError(friendlyError(err));
    } finally {
      setSaving(false);
    }
  };

  const done = data?.status === 'done';
  const dateLabel = formatDate(done ? data?.completed_at : data?.confirm_date);

  return (
    <div className="d-flex align-items-center justify-content-center min-vh-100 p-3" style={{ background: 'var(--app-surface-soft, #f8fafc)' }}>
      <div style={{ width: '100%', maxWidth: 480 }}>
        <AppCard title="Étape Klub">
          {loading && <AppSpinner label="Chargement…" />}
          {!loading && error && <AppAlert variant="danger">{error}</AppAlert>}
          {!loading && !error && data && (
            <>
              <p className="fw-semibold mb-1">{data.entreprise}</p>
              <p className="mb-3">{data.step_label}</p>
              {done ? (
                <AppAlert variant="success">
                  Cette étape est validée{dateLabel ? ` le ${dateLabel}` : ''}.
                </AppAlert>
              ) : (
                <>
                  <p className="mb-3">
                    En confirmant, l’étape sera marquée faite{dateLabel ? ` au ${dateLabel}` : ' aujourd’hui'}.
                  </p>
                  <AppButton type="button" icon="mdi:check" loading={saving} onClick={confirm}>
                    OK, je l’ai fait
                  </AppButton>
                </>
              )}
            </>
          )}
        </AppCard>
      </div>
    </div>
  );
};

export default KlubEtapeMailPage;
